"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorStatusEnum = void 0;
var ErrorStatusEnum;
(function (ErrorStatusEnum) {
    ErrorStatusEnum["SignedUpDifferently"] = "signedUpDifferently";
    ErrorStatusEnum["EmailNotConfirmed"] = "emailNotConfirmed";
    ErrorStatusEnum["SelectedPortfolioNotFound"] = "selectedPortfolioNotFound";
    ErrorStatusEnum["PortfoliosForUserNotFound"] = "portfoliosForUserNotFound";
    ErrorStatusEnum["PortfoliosLoadFailed"] = "portfoliosLoadFailed";
    ErrorStatusEnum["Maintenance"] = "maintenance";
    ErrorStatusEnum["TradesForUserNotFound"] = "tradesForUserNotFound";
    ErrorStatusEnum["UserNotFound"] = "userNotFound";
    ErrorStatusEnum["WatchlistNotFound"] = "watchlistNotFound";
    ErrorStatusEnum["CriticalNotificationNotFound"] = "criticalNotificationNotFound";
    ErrorStatusEnum["CriticalNotificationInvalidActiveRange"] = "criticalNotificationInvalidActiveRange";
    ErrorStatusEnum["ImporterNotFound"] = "importerNotFound";
    ErrorStatusEnum["ImporterAlreadyExists"] = "importerAlreadyExists";
    ErrorStatusEnum["CampaignLinkNotFound"] = "campaignLinkNotFound";
    ErrorStatusEnum["CampaignLinkSlugAlreadyExists"] = "campaignLinkSlugAlreadyExists";
    ErrorStatusEnum["CampaignLinkInvalidValidRange"] = "campaignLinkInvalidValidRange";
    ErrorStatusEnum["SymbolNotFound"] = "symbolNotFound";
    ErrorStatusEnum["SymbolHistoryNotFound"] = "symbolHistoryNotFound";
    ErrorStatusEnum["CurrencyNotFound"] = "currencyNotFound";
    ErrorStatusEnum["T212AutoImportFailed"] = "t212AutoImportFailed";
    ErrorStatusEnum["T212AutoImportInvalidToken"] = "t212AutoImportInvalidToken";
    ErrorStatusEnum["InvalidTradeDate"] = "invalidTradeDate";
    ErrorStatusEnum["CurrencyRateNotFound"] = "currencyRateNotFound";
    ErrorStatusEnum["ExistingUser"] = "existingUser";
    ErrorStatusEnum["BadConfirmationToken"] = "badConfirmationToken";
    ErrorStatusEnum["BadResetPasswordToken"] = "badResetPasswordToken";
    ErrorStatusEnum["EmailConfirmationTokenExpired"] = "emailConfirmationTokenExpired";
    ErrorStatusEnum["EmailResetPasswordTokenExpired"] = "emailResetPasswordTokenExpired";
    ErrorStatusEnum["EmailAlreadyConfirmed"] = "emailAlreadyConfirmed";
    ErrorStatusEnum["ImportTypeNotRecognized"] = "importTypeNotRecognized";
    ErrorStatusEnum["PortfolioIntegrationTypeNotRecognized"] = "portfolioIntegrationTypeNotRecognized";
    ErrorStatusEnum["StripeDuplicateEvent"] = "stripeDuplicateEvent";
    ErrorStatusEnum["StripeMoreActiveSubscriptions"] = "stripeMoreActiveSubscriptions";
    ErrorStatusEnum["StripeActiveSubscription"] = "stripeActiveSubscriptions";
    ErrorStatusEnum["StripeNoActiveSubscription"] = "stripeNoActiveSubscription";
    ErrorStatusEnum["StripePaymentFailed"] = "stripePaymentFailed";
    ErrorStatusEnum["StripeUpgradePaymentFailed"] = "stripeUpgradePaymentFailed";
    ErrorStatusEnum["StripeUpgradeFailedGeneric"] = "stripeUpgradeFailedGeneric";
    ErrorStatusEnum["UserMissingStripeCustomerId"] = "userMissingStripeCustomerId";
    ErrorStatusEnum["NoUserFromGoogle"] = "noUserFromGoogle";
    ErrorStatusEnum["NoUserFromTwitter"] = "noUserFromTwitter";
    ErrorStatusEnum["NoUserFromApple"] = "noUserFromApple";
    ErrorStatusEnum["EmailNotFound"] = "emailNotFound";
    ErrorStatusEnum["BadCredentials"] = "badCredentials";
    ErrorStatusEnum["ExternalLinkExpired"] = "externalLinkExpired";
    ErrorStatusEnum["NoLogoUrl"] = "noLogoUrl";
    ErrorStatusEnum["MissingDataEod"] = "missingDataEod";
    ErrorStatusEnum["PortfolioCantBeDeleted"] = "portfolioCantBeDeleted";
    ErrorStatusEnum["PortfolioIncludedInSummaryRequired"] = "portfolioIncludedInSummaryRequired";
    ErrorStatusEnum["NoAvailablePortfolios"] = "noAvailablePortfolios";
    ErrorStatusEnum["NoUploadedFile"] = "noUploadedFile";
    ErrorStatusEnum["NoResponseFromTradeImport"] = "noResponseFromTradeImport";
    ErrorStatusEnum["NoUserProfile"] = "noUserProfile";
    ErrorStatusEnum["EnvApiUrlUndefined"] = "envApiUrlUndefined";
    ErrorStatusEnum["EnvPageLimitUndefined"] = "envPageLimitUndefined";
    ErrorStatusEnum["SelectedIntervalNotFound"] = "selectedIntervalNotFound";
    ErrorStatusEnum["UseStoreMustBeInProvider"] = "useStoreMustBeInProvider";
    ErrorStatusEnum["FailedToCreateCheckoutSession"] = "failedToCreateCheckoutSession";
    ErrorStatusEnum["FailedToSwitchSubscriptionPrice"] = "failedToSwitchSubscriptionPrice";
    ErrorStatusEnum["FailedToGetSubscriptionPrice"] = "failedToGetSubscriptionPrice";
    ErrorStatusEnum["ImportFailed"] = "importFailed";
    ErrorStatusEnum["FailedToGetLeaderboard"] = "failedToGetLeaderboard";
    ErrorStatusEnum["LeaderboardForProvidedMonthAlreadyExists"] = "leaderboardForProvidedMonthAlreadyExists";
    ErrorStatusEnum["ExistingSymbolGrowthRate"] = "existingSymbolGrowthRate";
    ErrorStatusEnum["ShareSlugIsTaken"] = "shareSlugIsTaken";
    ErrorStatusEnum["SharedPortfolioDoesNotExist"] = "sharedPortfolioDoesNotExist";
    ErrorStatusEnum["PortfolioWithProvidedIdDoesNotExist"] = "portfolioWithProvidedIdDoesNotExist";
    ErrorStatusEnum["DemoPortfolioReadOnly"] = "demoPortfolioReadOnly";
    ErrorStatusEnum["SummaryPortfolioReadOnly"] = "summaryPortfolioReadOnly";
    ErrorStatusEnum["Default"] = "default";
    ErrorStatusEnum["Json"] = "json";
    ErrorStatusEnum["SymbolCurrencyNotFound"] = "symbolCurrencyNotFound";
    ErrorStatusEnum["NicknameWordsQuantityError"] = "nicknameWordsQuantityError";
    ErrorStatusEnum["NicknameIsEmptyError"] = "nicknameIsEmptyError";
    ErrorStatusEnum["NicknameAlreadyTaken"] = "nicknameAlreadyTaken";
    ErrorStatusEnum["SynchronizationFailed"] = "synchronizationFailed";
    ErrorStatusEnum["WebhookSignatureVerificationFailed"] = "webhookSignatureVerificationFailed";
    ErrorStatusEnum["EcomailMatchesWithMonery"] = "ecomailMatchesWithMonery";
    ErrorStatusEnum["MissingStripeSignatureHeader"] = "missingStripeSignatureHeader";
    ErrorStatusEnum["TemplateWithThisNameCouldNotBeFound"] = "templateWithThisNameCouldNotBeFound";
    ErrorStatusEnum["UserDisabledMailOverviews"] = "userDisabledMailOverviews";
    ErrorStatusEnum["NoSymbolsProvided"] = "noSymbolsProvided";
    ErrorStatusEnum["PasswordIsNotValid"] = "passwordIsNotValid";
    ErrorStatusEnum["MissingBaseUrlBetterStack"] = "missingBaseUrlBetterStack";
    ErrorStatusEnum["MissingLiveRecalculationHeartbeatIdBetterStack"] = "missingLiveRecalculationHeartbeatIdBetterStack";
    ErrorStatusEnum["MissingImportCurrencyRatesHeartbeatIdBetterStack"] = "missingImportCurrencyRatesHeartbeatIdBetterStack";
    ErrorStatusEnum["Unauthorized"] = "unauthorized";
    ErrorStatusEnum["MissingDataBetterStack"] = "missingDataBetterStack";
    ErrorStatusEnum["AffiliatePayoutLowerThanMinimum"] = "affiliatePayoutLowerThanMinimum";
    ErrorStatusEnum["AffiliatePayoutHigherThanActualCommissionsBalance"] = "affiliatePayoutHigherThanActualCommissionsBalance";
    ErrorStatusEnum["AffiliateCodeAlreadyExists"] = "affiliateCodeAlreadyExists";
    ErrorStatusEnum["AppleInvalidReceipt"] = "INVALID_RECEIPT";
    ErrorStatusEnum["AppleReceiptAlreadyUsed"] = "RECEIPT_ALREADY_USED";
    ErrorStatusEnum["AppleApiUnavailable"] = "APPLE_API_UNAVAILABLE";
    ErrorStatusEnum["AppleManagedSubscription"] = "MANAGED_BY_APPLE";
})(ErrorStatusEnum = exports.ErrorStatusEnum || (exports.ErrorStatusEnum = {}));
//# sourceMappingURL=error-status-enum.js.map